import React from 'react'
import { useToggle } from 'react-use'

import { DropDownIconButton } from '~/components/elements/DropDownIconButton'
import { VStack } from '~/components/elements/VStack'
import {
  CopyToClipboardButton,
  type CopyToClipboardButtonProps,
} from '~/components/features/CopyToClipboardButton'
import {
  DownloadAsPngButton,
  type DownloadAsPngButtonProps,
} from '~/components/features/DownloadAsPngButton'
import {
  GetSharedUrlButton,
  type GetSharedUrlButtonProps,
} from '~/components/features/GetSharedUrlButton'
import { SaveDocumentImageButton } from '~/components/features/SaveDocumentImageButton'
import {
  SaveDocumentImageDialog,
  type SaveDocumentImageDialogProps,
} from '~/components/features/SaveDocumentImageDialog'

export type ShareDropDownMenuButtonProps<ColumnKey extends string> = {
  copyToClipboard?: CopyToClipboardButtonProps<ColumnKey>
  downloadAsPng?: DownloadAsPngButtonProps
  getSharedUrl?: GetSharedUrlButtonProps
  saveDocumentImage?: Omit<SaveDocumentImageDialogProps, 'onClose'>
}

export const ShareDropDownMenuButton = <ColumnKey extends string>({
  copyToClipboard,
  downloadAsPng,
  getSharedUrl,
  saveDocumentImage,
}: ShareDropDownMenuButtonProps<ColumnKey>) => {
  const [
    isVisibleSaveDocumentImageDialog,
    toggleIsVisibleSaveDocumentImageDialog,
  ] = useToggle(false)

  return (
    <>
      <DropDownIconButton icon="share">
        <VStack spacing={1}>
          {copyToClipboard && <CopyToClipboardButton {...copyToClipboard} />}

          {downloadAsPng && <DownloadAsPngButton {...downloadAsPng} />}

          {getSharedUrl && <GetSharedUrlButton {...getSharedUrl} />}

          {saveDocumentImage && (
            <SaveDocumentImageButton
              onClick={toggleIsVisibleSaveDocumentImageDialog}
            />
          )}
        </VStack>
      </DropDownIconButton>

      {saveDocumentImage && isVisibleSaveDocumentImageDialog && (
        <SaveDocumentImageDialog
          {...saveDocumentImage}
          onClose={toggleIsVisibleSaveDocumentImageDialog}
        />
      )}
    </>
  )
}
